import { render, staticRenderFns } from "./ClientAbout.vue?vue&type=template&id=129cff9a&scoped=true&"
import script from "./ClientAbout.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ClientAbout.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ClientAbout.vue?vue&type=style&index=0&id=129cff9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129cff9a",
  null
  
)

export default component.exports